<template>
  <modal
    name="multiDraftMsg"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    :classes="['custom']"
    :clickToClose="false"
    :height="210"
  >
    <div class="container">
      <div class="content">
        <div>您的项目已在其他页面打开</div>
        <div>继续编辑将会覆盖原有项目数据，为避免数据错乱，请复制新项目后再进入编辑</div>
      </div>
      <div class="footer">
        <div
          class="button button--primary"
          @click="goLink"
        >确定</div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      selectedRecord: null
    }
  },
  created () {

  },
  methods: {
    goLink () {
      this.clickToClose();
      window.location.assign('/workbench/creation/draft');
    },
    clickToClose () {
      this.$modal.hide('multiDraftMsg');
    },
    beforeOpen ({ params } = {}) {
      this.selectedRecord = params;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 420px;
  height: 210px;
  margin: auto;
  padding-top: 48px;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
}

.content {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 24px;
  min-height: 44px;
  & > div {
    &:nth-child(1) {
      margin-bottom: 1em;
      font-weight: bold;
    }
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;

  > div:nth-of-type(1) {
    margin-right: 25px;
  }
}

.button {
  width: 160px;
  height: 40px;
  border-radius: 8px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/multiDraftMsg.vue